import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';

const getCountHeight = ref => {
    return parseFloat(getComputedStyle(ref)['height'], 10);
};

class Ellipsis extends React.PureComponent {
    static defaultProps = {
        line: 2,
        ellipsis: '...',
        addOn: null,
        customClass: '',
    };

    static propTypes = {
        line: PropTypes.number,
        ellipsis: PropTypes.string,
        children: PropTypes.string,
        addOn: PropTypes.element,
        customClass: PropTypes.string,
        fold: PropTypes.bool,
    };

    state = {
        overHeight: true,
    };

    componentDidMount() {
        const { fold } = this.props;

        this.lineHeight = this.getLineHeight();
        const overHeight = this.getIfOverHeight();

        if (overHeight) {
            if (fold) {
                this.removeTpl();
                this.clipText();
            }
        } else {
            this.setState({ overHeight });
        }
    }

    getIfOverHeight() {
        return getCountHeight(this.textRef) / this.lineHeight > this.props.line;
    }

    getLineHeight() {
        return this.getHeightRef.offsetHeight;
    }

    removeTpl() {
        try {
            this.textRef.removeChild(this.getHeightRef);
        } catch (err) {
            console.error(err);
        }
    }

    clipText() {
        const { line, ellipsis } = this.props;
        const { textRef, lineHeight } = this;
        let text = textRef.textContent;

        while (getCountHeight(textRef) / lineHeight > line) {
            text = text.slice(0, text.length - 1);
            textRef.innerText = text + ellipsis;
        }
    }
    render() {
        const { addOn, customClass, fold, children } = this.props;
        const { overHeight } = this.state;

        return (
            <div className={`${styles.wrap} ${customClass}`}>
                {fold && overHeight ? (
                    <>
                        {addOn}
                        <div className={styles.text} ref={current => (this.textRef = current)}>
                            {children}
                            <span ref={current => (this.getHeightRef = current)} style={{ visibility: 'hidden' }}>
                                获取高度
                            </span>
                        </div>
                    </>
                ) : (
                    children
                )}
            </div>
        );
    }
}

export default errorBoundary(Ellipsis);
